<template>
    <div class="exam-content">
        <div class="exam-head">
            <div class="exam-name">{{ examInfo.name }}</div>
            <div class="exam-title">考试信息</div>
            <div class="exam-info-list">
                <div class="exam-info-each">
                    <div class="exam-info-num">{{ examInfo.duration || 0 }}分钟</div>
                    <div class="exam-info-num-title">考试时长</div>
                </div>
                <div class="exam-info-each">
                    <div class="exam-info-num">{{ examInfo.countItem || 0 }}</div>
                    <div class="exam-info-num-title">题目数量</div>
                </div>
                <div class="exam-info-each">
                    <template v-if="examInfo.answeringTimes > 0">
                        <div class="exam-info-num">{{ examInfo.countTimes }}/{{ examInfo.answeringTimes }}</div>
                    </template>
                    <template v-else>
                        <div class="exam-info-num">{{ examInfo.countTimes || 0 }}</div>
                    </template>
                    <div class="exam-info-num-title">考试次数</div>
                </div>
            </div>
        </div>
        <div class="exam-data">
            <div class="exam-title">考试详情</div>
            <div class="exam-data-list">
                <div class="exam-data-each">
                    <div class="exam-data-title">满分：</div>
                    <div class="exam-data-text">{{ examInfo.fullScore || 0 }}分</div>
                </div>
                <div class="exam-data-each">
                    <div class="exam-data-title">及格分：</div>
                    <div class="exam-data-text">{{ examInfo.passScore || 0 }}分</div>
                </div>
                <div class="exam-data-each">
                    <div class="exam-data-title">开放时间：</div>
                    <div class="exam-data-text">{{ examInfo.startTime ? formattedDateTime(examInfo.startTime) : '' }}
                    </div>
                </div>
                <div class="exam-data-each" v-if="examInfo.endTime !== null && examInfo.endTime !== undefined">
                    <div class="exam-data-title">截止时间：</div>
                    <div class="exam-data-text">{{ examInfo.endTime ? formattedDateTime(examInfo.endTime) : '' }}</div>
                </div>
                <div class="exam-info-list next" v-if= "examResultVo !== null">
                    <div class="exam-info-each">
                        <div class="exam-info-num">{{ examResultVo.countRight || 0 }}</div>
                        <div class="exam-info-num-title">正确</div>
                    </div>
                    <div class="exam-info-each">
                        <div class="exam-info-num">{{ examResultVo.countError || 0 }}</div>
                        <div class="exam-info-num-title">错误</div>
                    </div>
                    <div class="exam-info-each">
                        <div class="exam-info-num">{{ examResultVo.score || 0 }}</div>
                        <div class="exam-info-num-title">得分</div>
                    </div>
                </div>
            </div>
            <div class="all-btn">
                <div class="start-btn blue" v-if="lookBtnShow" @click="toExamWorkResult">答题详情</div>
                <div class="start-btn blue" v-if="startBtnShow" @click="toExamWork">开始答题</div>
                <div class="start-btn blue" v-if="againBtnShow" @click="toExamWork">再答一次</div>
                <div class="back-btn" @click="toTeachDetail">返回课程</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getExamDetails } from '@/api/common'
import { showToast } from 'vant'
export default {
    name: 'ExamDetailPage',
    props: ['id'],
    data() {
        return {
            merchantId: '',
            examId: '',
            teachingId: '',
            examInfo: {},
            examResultVo: null,
            startBtnShow: false,
            againBtnShow: false,
            lookBtnShow: false
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.examId = this.$route.query.teachingId;
        this.teachingId = this.$route.query.teachingId;
        this.getExamInfo();
    },
    methods: {
        getExamInfo() {
            let params = {
                teachingGatherId: this.examId
            };
            getExamDetails(params).then((res) => {
                if (res.code !== 200 && res.code !== 401) {
                    showToast(res.msg)
                    return;
                }
                let info = res.data;
                this.examInfo = info;
                this.examResultVo = res.examResultVo;
                let list = localStorage.getItem('examResult') || null;
                const propName = 'examResult' + this.examId;
                if (list != null && JSON.parse(list)[propName] != null && info.resultDisplay === '1') {
                    this.lookBtnShow = true;
                }
                let now = new Date().getTime();
                let start = new Date(info.startTime).getTime();
                if(now < start) return;
                if (info.countTimes == 0) {
                    if (info.endTime === null) {
                        this.startBtnShow = true;
                    } else {
                        let end = new Date(info.endTime).getTime();
                        if (now < end) {
                            this.startBtnShow = true;
                        }
                    }
                }
                if ((info.answeringTimes > 0 && info.countTimes < info.answeringTimes && info.countTimes > 0) || (info.answeringTimes == 0 && info.countTimes > 0)) {

                    if (info.endTime === null) {
                        this.againBtnShow = true;
                    } else {
                        let end = new Date(info.endTime).getTime();
                        if (now < end) {
                            this.againBtnShow = true;
                        }
                    }
                }
            })
        },
        formattedDateTime(item) {
            return this.$formatDateTime(new Date(item), 'YYYY-MM-DD HH:mm');
        },
        toTeachDetail() {
            this.$router.push({
                path: '/home/' + this.merchantId
            });
        },
        toExamWork() {
            this.$router.push({
                path: '/examWork/' + this.merchantId, query: {
                    teachingId: this.teachingId,
                    examProId: this.examInfo.id,
                }
            });
        },
        toExamWorkResult() {
            this.$router.push({
                path: '/examWork/' + this.merchantId, query: {
                    teachingId: this.teachingId,
                    examProId: this.examInfo.id,
                    result: '1',
                }
            });
        }
    }
}
</script>
<style scoped>
.exam-content {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f5f5f5;
    overflow: hidden;
}

.exam-head {
    padding: 15px;
    margin-bottom: 5px;
    text-align: left;
    background: #fff;
}

.exam-data {
    flex: 1;
    padding: 15px 15px 45px 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    text-align: left;
}

.exam-name {
    margin-bottom: 15px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
}

.exam-title {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
}

.exam-info-list {
    display: flex;
    padding: 0 20px;
    margin-top: 20px;
    justify-content: space-between;
}

.exam-info-list.next {
    margin-top: 40px;
}

.exam-info-each {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.exam-info-num {
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
}

.exam-info-num-title {
    margin-top: 10px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #6D7278;
    letter-spacing: 0;
    font-weight: 400;
}

.exam-data-list {
    flex: 1;
    margin: 15px 0;
    overflow: hidden;
}

.all-btn {
    padding: 0 25px;
    margin-top: 30px;
    overflow: hidden;
}

.start-btn {
    margin-bottom: 15px;
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #CCCCCC;
    border-radius: 32px;
}


.start-btn.blue {
    background: #0095D9;
}

.back-btn {
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #CCCCCC;
    border-radius: 32px;
}

.exam-data-each {
    display: flex;
    margin-bottom: 10px;
    overflow: hidden;
}

.exam-data-title {
    margin-right: 20px;
    width: 60px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #6D7278;
    letter-spacing: 0;
    font-weight: 400;
}

.exam-data-text {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 400;
}
</style>